import { useNavigate } from "react-router-dom";
import TRAIcon from "../icons/TRAIcon";
import styles from "./shell.module.css";
import { cn } from "../utils/cn";

/** Global search entry — navigates to Discover (Wave 1; full search UI is later waves). */
export default function GlobalSearchEntry({ className, to = "/discover" }) {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className={cn(styles.iconBtn, styles.headerIconBtn, className)}
      aria-label="Search"
      onClick={() => navigate(to)}
    >
      <TRAIcon name="search" size="md" />
    </button>
  );
}
